import { Link, useLocation } from 'react-router-dom';
import Seo from '@/components/base/Seo';
import SiteLayout from '@/components/feature/SiteLayout';
import { categories } from '@/data/categories';
import { articles } from '@/data/articles';

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <Seo
        title="页面不存在 - 吃瓜网"
        description="你访问的页面不存在或已被移动，可以返回首页，或从栏目导航继续浏览娱乐热点、热剧综、网络热梗与瓜圈观察内容。"
        path="/404"
      />
      <section className="max-w-container mx-auto px-4 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl">
          <p className="font-heading text-7xl md:text-9xl font-black text-primary-200 leading-none select-none">
            404
          </p>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            这个瓜，好像摘晚了
          </h1>
          <p className="mt-4 text-base leading-8 text-foreground-600">
            你访问的页面不存在，或者已经被移动到别处。下面是几个可以继续逛的入口。
          </p>
          <p className="mt-2 text-xs text-foreground-400 font-mono break-all">
            {location.pathname}
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/"
              className="h-11 px-6 inline-flex items-center rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/search"
              className="h-11 px-6 inline-flex items-center rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              去搜索内容
            </Link>
          </div>
        </div>

        <div className="mt-14">
          <h2 className="font-heading text-lg font-semibold text-foreground-950 mb-4">
            从栏目继续
          </h2>
          <div className="flex flex-wrap gap-2">
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="px-4 py-2 rounded-full border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors"
              >
                {c.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-12">
          <h2 className="font-heading text-lg font-semibold text-foreground-950 mb-4">
            或者看看这几篇
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {articles.slice(0, 3).map((a) => (
              <Link
                key={a.slug}
                to={`/article/${a.slug}`}
                className="p-5 rounded-lg border border-background-200 hover:border-primary-300 transition-colors"
              >
                <span className="font-heading text-sm font-medium text-foreground-900 line-clamp-2">
                  {a.title}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}